enum Roles {
    Administrator = 'administrator',
    Owner = 'owner',
    Operator = 'operator',
    Surveyor = 'surveyor',
    Client = 'client',
    ReadOnly = 'readOnly',
    AccountManager = 'accountManager',
    ConfigurationManager = 'configurationManager',
}

export { Roles };
